import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.LossCodeCategory.List.IRequest;
type Response = Api.Core.LossCodeCategory.List.IResponse;
type Headers = Api.Core.LossCodeCategory.List.IHeaders;
const url = '/api/Claims/LossCodeCategory';
export default async function lossCodeCategoryListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
